import { CalendarMonth } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import { format } from 'date-fns'

import { formatOsaTimeRange } from '../../../scout-scheduling/utils/timeRange.utils.ts'
import type { Appointment } from '../../types.ts'
import Header from '../Header'
import Item from '../Item'

interface Props {
  appointment: Appointment
}

export const SectionCustomerProposedDates = ({ appointment }: Props) => {
  return (
    <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 45%' } }}>
      <Header label="Customer Proposed Dates" />
      <Stack spacing={2}>
        {[
          {
            label: 'Option 1',
            date: appointment.proposedDate1,
            option: appointment.proposedTimeRange1,
          },
          {
            label: 'Option 2',
            date: appointment.proposedDate2,
            option: appointment.proposedTimeRange2,
          },
          {
            label: 'Option 3',
            date: appointment.proposedDate3,
            option: appointment.proposedTimeRange3,
          },
        ].map(({ label, date, option }, index) => {
          let formattedDate = 'Not provided'

          if (date) {
            const baseDate = format(new Date(date), 'MMMM do, yyyy')
            formattedDate = option
              ? `${baseDate} - ${formatOsaTimeRange(String(option), new Date(date))}`
              : baseDate
          }

          return (
            <Item
              key={index}
              variant={!date ? 'secondary' : 'primary'}
              label={label}
              value={formattedDate}
              Icon={CalendarMonth}
            />
          )
        })}
      </Stack>
    </Box>
  )
}

export default SectionCustomerProposedDates
